import React, { Component } from 'react';
import PropTypes from 'prop-types';

const clickOutsideEvents = ['mousedown', 'touchend'];

const isDescendant = (el, target) =>
  target !== null ? el === target || isDescendant(el, target.parentNode) : false;

export default class ClickOutside extends Component {
  static propTypes = {
    children: PropTypes.node,
    onClickOutside: PropTypes.any,
  };

  componentDidMount() {
    if (!this.props.onClickOutside) return;
    clickOutsideEvents.forEach((e) => {
      document.addEventListener(e, this.handleClickOutside);
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.onClickOutside !== this.props.onClickOutside) {
      clickOutsideEvents.forEach((e) => document.removeEventListener(e, this.handleClickOutside));

      if (this.props.onClickOutside) {
        clickOutsideEvents.forEach((e) => document.addEventListener(e, this.handleClickOutside));
      }
    }
  }

  componentWillUnmount() {
    clickOutsideEvents.forEach((e) => document.removeEventListener(e, this.handleClickOutside));
  }

  handleClickOutside = (e) => {
    const el = this.node;

    if (document.documentElement.contains(e.target) && !isDescendant(el, e.target)) {
      this.props.onClickOutside(e);
    }
  };

  render() {
    return <span ref={(node) => (this.node = node)}>{this.props.children}</span>;
  }
}
